/* Edit a Measura line using its canonical measurement and the app storefront API. */
import { CartLinesUpdateEvent } from '@shopify/events';
(function(){
  if(window.TessutiMeasuraCartLineReady) return;
  window.TessutiMeasuraCartLineReady=true;
  function propsOf(box){try{var p=JSON.parse(box.dataset.properties||'{}')||{};return Array.isArray(p)?Object.fromEntries(p):p}catch(e){return {}}}
  function measurementOf(props){
    try{
      var raw=String(props._measura_data||'{}');
      var textarea=document.createElement('textarea'); textarea.innerHTML=raw;
      var data=JSON.parse(textarea.value);
      return data.measurement && data.measurement.dimensions && data.measurement.dimensions[0];
    }catch(e){return null}
  }
  function error(box,message){
    var target=box.querySelector('.tessuti-measura-cart-line__error');
    target.textContent=message||''; target.hidden=!message;
  }
  function initialize(box){
    if(box.dataset.measuraReady==='1')return;
    box.dataset.measuraReady='1';
    var originalProps=propsOf(box);
    var original=measurementOf(originalProps);
    if(!original)return;
    var input=box.querySelector('input');
    var unit=box.querySelector('.tessuti-measura-cart-line__unit');
    input.value=String(original.value);
    unit.textContent=original.unit;
    var current=Number(original.value);
    var savedBase=Number((function(){
      try { var d=JSON.parse(originalProps._measura_data); return d.unitMeasurement && d.unitMeasurement.value; }
      catch(e) { return 0; }
    })());
    var savedQuantity=Number(box.dataset.quantity);
    var expectedQuantity=savedBase>0 ? current/savedBase : NaN;
    var inconsistent=!(savedBase>0 && Math.abs(expectedQuantity-Math.round(expectedQuantity))<1e-6 && Math.round(expectedQuantity)===savedQuantity);
    var visibleLength=originalProps['Net length'];
    if(visibleLength){
      var shown=String(visibleLength).match(/^\s*(\d+(?:\.\d+)?)\s*(\S+)/);
      if(shown && (Math.abs(Number(shown[1])-current)>1e-6 || shown[2]!==original.unit)) inconsistent=true;
    }
    if(originalProps.Quantity){
      var legacy=String(originalProps.Quantity).match(/^\s*(\d+(?:\.\d+)?)\s*(\S+)/);
      if(legacy && (Math.abs(Number(legacy[1])-current)>1e-6 || legacy[2]!==original.unit)) inconsistent=true;
    }
    if(inconsistent){
      error(box,'This cart item has conflicting measurement and price data. Remove it and add it again.');
      input.disabled=true;
      box.querySelectorAll('button').forEach(function(button){button.disabled=true});
      return;
    }
    var busy=false;
    async function change(next){
      if(busy)return;
      busy=true;error(box,'');
      try{
        if(!Number.isFinite(next)||next<=0)throw new Error('Enter a valid measurement.');
        if(!window.Measura || !window.Measura.getVariant || !window.Measura.buildLineItemProperties)
          throw new Error('Measurement calculator is still loading. Please try again.');
        var variant=await window.Measura.getVariant({
          productId:box.dataset.productId,productHandle:box.dataset.handle,variantId:box.dataset.variantId
        });
        var base=Number(variant && variant.unitMeasurement && variant.unitMeasurement.value);
        if(!base || variant.unitMeasurement.unit!==original.unit)
          throw new Error('Measurement setup is incomplete.');
        if(Math.abs(base-savedBase)>1e-8)
          throw new Error('Measurement pricing has changed. Remove and add this item again.');
        var rule=variant.purchaseCondition||{};
        var min=Number(rule.min)||base;
        var max=Number(rule.max)||Infinity;
        var increment=Number(rule.increment)||base;
        if(next<min-1e-6 || next>max+1e-6 || Math.abs((next-min)/increment-Math.round((next-min)/increment))>1e-6)
          throw new Error('Choose a valid Measura measurement.');
        var units=Math.round(next/base);
        if(units<1||Math.abs(units*base-next)>1e-6)
          throw new Error('Choose a measurement in steps of '+base+' '+original.unit+'.');
        var oldProps=propsOf(box),baseProps={};
        Object.keys(oldProps).forEach(function(k){
          if(k.charAt(0)!=='_' && !/^(Net |Unit price|Quantity$)/i.test(k))baseProps[k]=oldProps[k];
        });
        var built=await window.Measura.buildLineItemProperties({
          productId:box.dataset.productId,productHandle:box.dataset.handle,variantId:box.dataset.variantId,
          measurement:{dimensions:[{value:next,unit:original.unit}]},baseProperties:baseProps
        });
        if(!built.some(function(p){return p.name==='_measura_data'}))
          throw new Error('Measurement data could not be prepared.');
        var properties={};
        built.forEach(function(p){properties[p.name]=String(p.value)});
        var response=await fetch('/cart/change.js',{
          method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({id:box.dataset.key,quantity:units,properties:properties})
        });
        var cart=await response.json();
        if(!response.ok||cart.status)throw new Error(cart.description||cart.message||'Could not update cart.');
        current=next; input.value=String(next);
        document.dispatchEvent(new CustomEvent('tessuti:cart-change'));
        if(box.dataset.context==='cart'){window.location.reload();return}
        document.dispatchEvent(new CartLinesUpdateEvent({
          action:'update',context:'cart',
          lines:[{id:box.dataset.key,quantity:units}],
          promise:Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail:{items:cart.items,source:'tessuti-measura-cart',itemCount:cart.item_count,didError:false}})
        }));
      }catch(e){error(box,e.message||'Could not update measurement.');input.value=String(current)}
      finally{busy=false}
    }
    async function stepBy(direction){
      try{
        if(!window.Measura || !window.Measura.getVariant)throw new Error('Measurement calculator is still loading.');
        var variant=await window.Measura.getVariant({productId:box.dataset.productId,productHandle:box.dataset.handle,variantId:box.dataset.variantId});
        var step=Number(variant && variant.purchaseCondition && variant.purchaseCondition.increment)||Number(variant && variant.unitMeasurement && variant.unitMeasurement.value);
        if(!step)throw new Error('Measurement step is unavailable.');
        change(Math.round((current+direction*step)*1000000)/1000000);
      }catch(e){error(box,e.message||'Could not read measurement step.')}
    }
    box.querySelector('.tessuti-measura-cart-line__minus').addEventListener('click',function(){stepBy(-1)});
    box.querySelector('.tessuti-measura-cart-line__plus').addEventListener('click',function(){stepBy(1)});
    input.addEventListener('change',function(){change(Number(input.value))});
    input.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();change(Number(input.value))}});
  }
  function mount(){document.querySelectorAll('.tessuti-measura-cart-line').forEach(initialize)}
  mount();
  new MutationObserver(mount).observe(document.body,{childList:true,subtree:true});
})();